// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KvwQ","footer":"styles_footer__1yt_3","passCodeTooltip":"styles_passCodeTooltip__3e3rW"};